module.exports = __webpack_public_path__ + "img/port-of-origin.a5b5f16b.svg";